import changeStatus from './changeStatus'
import creatorUserMail from './creatorUserMail'
import massApproval from './massApproval'
import paymentRuns from './paymentRuns'
import reporting from './reporting'

export default {
    changeStatus,
    creatorUserMail,
    massApproval,
    paymentRuns,
    reporting,
}